/*
 * Beside an open document the drive's column folds away at every width (S-01 §3.4; DS2-D7): the
 * document has a column of its own, the contents panel, and three columns of chrome beside the text's
 * 42 rem do not fit at 1 440 px. Nothing on the document page brings the drive's column back; the way
 * to the folder is the panel's head row and the breadcrumb, and Recent and Starred are a press on the
 * rail away.
 *
 * Whether an address is a document's is the slice's to answer: the page that resolved the key
 * (`../open.tsx`) wrote the item there before it drew the document. A link id names a document
 * whatever the slice holds — a person outside the drive who opened it by its link has no item there.
 */

import { client } from "../../../core/store/store.ts"
import { isLinkId, keyOfPath, namedBy } from "../navigation.ts"
import { driveSlice } from "../reducer.ts"
import { KindDocument } from "../wire/drive.gen.ts"

/** Whether the address names a document the reader has open. */
export function foldsBesideDocument(pathname: string): boolean {
	const key = keyOfPath(pathname)
	if (key === "") return false
	if (isLinkId(key)) return true
	return Object.values(driveSlice(client.model).items).some(
		(item) => namedBy(item, key) && item.kind === KindDocument,
	)
}

/** The column folds at every width beside a document; the person's own choice still wins. */
export const DRIVE_FOLD = { belowPx: Number.POSITIVE_INFINITY, on: foldsBesideDocument }
